import { FC, useState } from "react";
import { Text, Flex, Spinner } from "@chakra-ui/react";
import { InfoIcon } from "lucide-react";
import { toaster } from "../../../components/ui/toaster";
import Button from "../../../components/Button";

type Props = {
  email?: string;
};

const EmailNotVerifiedMessage: FC<Props> = ({ email }) => {
  const [resendTimeout, setResendTimeout] = useState(0);

  const isResendEmailActive = resendTimeout === 0;

  const sendConfirmationEmail = async () => {
    await fetch("/api/account/send-verify-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    toaster.info({
      title: `Confirmation email sent to ${email}`,
    });

    setResendTimeout(30);

    const interval = setInterval(() => {
      setResendTimeout(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);
  };

  return (
    <div>
      <Text mb={3}>Hi {email}!</Text>

      <Text mb={5}>
        We need to verify your email. Please check your emails to verify your
        account or
        <Button
          visual="link"
          disabled={!isResendEmailActive}
          onClick={sendConfirmationEmail}
          _hover={{ bg: "none" }}
        >
          resend confirmation email
          {!isResendEmailActive && (
            <>
              <Spinner size="sm" color="blue.solid" />
              <Text as="span" fontWeight="normal" textDecoration="none">
                wait {resendTimeout}s
              </Text>
            </>
          )}
        </Button>
      </Text>

      <Flex alignItems="center" gap={2}>
        <InfoIcon size={16} />
        <Text fontSize="sm">You may need to check your spam/junk folder.</Text>
      </Flex>
    </div>
  );
};

export default EmailNotVerifiedMessage;
